import { CircularProgress } from "@mui/material";
import { Alert } from "@platform/design-system";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { signIn } from "./signIn";
import { handleAuth0Callback } from "./sso";

import type { ReactNode } from "react";

/** Where Auth0 returns after sign-in: stores the session, then opens the page the user started on. */
export const CallbackPage = (): ReactNode => {
  const navigate = useNavigate();
  const [error, setError] = useState<string>();

  // Finishing the redirect is a side effect on Auth0 and the session store.
  useEffect(() => {
    if (signIn.kind !== "auth0") {
      void navigate("/", { replace: true });
      return;
    }
    handleAuth0Callback(signIn.tenant, window.location.href).then(
      (returnTo) => navigate(returnTo, { replace: true }),
      (failure: unknown) =>
        setError(failure instanceof Error ? failure.message : String(failure)),
    );
  }, [navigate]);

  return error ? (
    <Alert
      data-testid="golden-callback-error"
      severity="error"
      title="Sign-in failed"
    >
      {error}
    </Alert>
  ) : (
    <CircularProgress data-testid="golden-callback" aria-label="Signing in" />
  );
};
